import React from 'react';
import { UI_SCREEN_STYLES } from '../../styles/UISystem';
import IconBack from '../../components/UISystem/Icons/IconBack';
import {
  FormConnectionExample,
  FormConnectionNoteExample,
  PhoneInputFieldExample,
  ContactFieldExample,
  ContactFieldsExample,
  SelectionRowExample,
} from '../../components/UISystem/Forms';

/**
 * Forms Screen - UI System subpage
 *
 * Displays the form system documentation using reusable form components
 */
const FormsScreen = ({ onBack }) => {
  return (
    <div style={UI_SCREEN_STYLES.container}>
      {/* Header with back button and title */}
      <div style={UI_SCREEN_STYLES.header}>
        {/* Back button */}
        <IconBack onClick={onBack} />

        {/* Title */}
        <h1 style={UI_SCREEN_STYLES.title}>Forms</h1>
      </div>

      {/* Horizontal line */}
      <div style={UI_SCREEN_STYLES.divider} />

      {/* Content */}
      <div style={UI_SCREEN_STYLES.content}>
        {/* FormConnection Section */}
        <div style={{ marginBottom: '60px' }}>
          <FormConnectionExample />
        </div>

        {/* FormConnectionNote Section */}
        <div style={{ marginBottom: '60px' }}>
          <FormConnectionNoteExample />
        </div>

        {/* PhoneInputField Section */}
        <div style={{ marginBottom: '60px' }}>
          <PhoneInputFieldExample />
        </div>

        {/* ContactField Section */}
        <div style={{ marginBottom: '60px' }}>
          <ContactFieldExample />
        </div>

        {/* SelectionRow Section */}
        <div style={{ marginBottom: '60px' }}>
          <SelectionRowExample />
        </div>

        {/* ContactFields Section */}
        <ContactFieldsExample />
      </div>
    </div>
  );
};

export default FormsScreen;
